module.exports = __webpack_public_path__ + "img/Machinery-transport.f9e04c3.svg";